(()=>{'use strict';
if(window.WV7Homepage){window.WV7Homepage();return;}
function init(root){if(!root||root.dataset.wvInitialized==='true')return;root.dataset.wvInitialized='true';const wv={};const assets=JSON.parse(root.querySelector('[data-wv-assets]').textContent);const wvAsset=function(p){if(assets[p])return assets[p];if(p&&String(p).indexOf('assets/')===0&&typeof console!=='undefined'&&console.warn)console.warn('[WV] missing asset map entry:',p);return ''};
wv.WV_CATALOG = [
  {
    "id": "premium",
    "name": "Sauna Premium",
    "nameEn": "Premium sauna",
    "category": "saunas",
    "tag": "Saunas",
    "tagEn": "Saunas",
    "image": wvAsset("assets/catalog/sauna-premium-native-rgb-v4.webp"),
    "contain": false,
    "summary": "Cristal panorámico, iluminación ambiental y acabados personalizables.",
    "summaryEn": "Panoramic glass, ambient lighting and customisable finishes.",
    "features": [
      "Fabricación a medida",
      "Distribución, madera e iluminación según proyecto"
    ],
    "featuresEn": [
      "Made to measure",
      "Layout, wood and lighting to suit the project"
    ],
    "specs": {
      "Configuración": "Según proyecto",
      "Característica": "Fabricación a medida",
      "Detalle": "Distribución, madera e iluminación según proyecto"
    },
    "specsEn": {
      "Configuration": "Depends on the project",
      "Feature": "Made to measure",
      "Detail": "Layout, wood and lighting to suit the project"
    },
    "source": "Catálogo de saunas",
    "sourceEn": "Sauna catalogue",
    "page": 3,
    "diagram": false,
    "imageSource": "Catálogo general",
    "imageSourceEn": "General catalogue",
    "imagePage": 21,
    "imageWidth": 1200,
    "imageHeight": 1500,
    "imageAlt": "Sauna Premium. Cristal panorámico, iluminación ambiental y acabados personalizables.",
    "imageAltEn": "Premium sauna. Panoramic glass, ambient lighting and customisable finishes."
  },
  {
    "id": "wv-g22-professional",
    "name": "WV-G22 Professional",
    "nameEn": "WV-G22 Professional",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p15-native.png"),
    "contain": true,
    "summary": "Bañera de la línea profesional para proyectos de interior y exterior.",
    "summaryEn": "Professional-line tub for indoor and outdoor projects.",
    "features": [
      "Construcción WPC y acero inoxidable",
      "Dimensiones: 2.000 × 843 × 750 mm",
      "Control WiFi y aplicación iOS / Android"
    ],
    "featuresEn": [
      "WPC and stainless steel construction",
      "Dimensions: 2,000 × 843 × 750 mm",
      "WiFi control and iOS / Android app"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Construcción WPC y acero inoxidable",
      "Dimensiones": "2.000 × 843 × 750 mm",
      "Equipamiento": "Control WiFi y aplicación iOS / Android"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "WPC and stainless steel construction",
      "Dimensions": "2,000 × 843 × 750 mm",
      "Equipment": "WiFi control and iOS / Android app"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 15,
    "diagram": false,
    "imageWidth": 1448,
    "imageHeight": 1086,
    "imageAlt": "WV-G22 Professional. Bañera de la línea profesional para proyectos de interior y exterior.",
    "imageAltEn": "WV-G22 Professional. Professional-line tub for indoor and outdoor projects."
  },
  {
    "id": "wv300",
    "name": "WV300",
    "nameEn": "WV300",
    "category": "luz",
    "tag": "Fotobiomodulación",
    "tagEn": "Photobiomodulation",
    "image": wvAsset("assets/catalog/pbm-p6-0.jpeg"),
    "contain": false,
    "summary": "Panel de luz roja e infrarrojo cercano, con soporte ajustable.",
    "summaryEn": "Red and near-infrared light panel with an adjustable stand.",
    "features": [
      "300 diodos",
      "Dimensiones: 910 × 298 × 60 mm",
      "Peso neto: 8,6 kg",
      "Modos rojo, infrarrojo cercano o ambos"
    ],
    "featuresEn": [
      "300 diodes",
      "Dimensions: 910 × 298 × 60 mm",
      "Net weight: 8.6 kg",
      "Red, near-infrared or combined modes"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "300 diodos",
      "Dimensiones": "910 × 298 × 60 mm",
      "Peso neto": "8,6 kg",
      "Complemento": "Modos rojo, infrarrojo cercano o ambos"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "300 diodes",
      "Dimensions": "910 × 298 × 60 mm",
      "Net weight": "8.6 kg",
      "Extra": "Red, near-infrared or combined modes"
    },
    "source": "Catálogo de fotobiomodulación",
    "sourceEn": "Photobiomodulation catalogue",
    "page": 6,
    "diagram": false,
    "imageWidth": 832,
    "imageHeight": 1248,
    "imageAlt": "WV300. Panel de luz roja e infrarrojo cercano, con soporte ajustable.",
    "imageAltEn": "WV300. Red and near-infrared light panel with an adjustable stand."
  },
  {
    "id": "finlandesa",
    "name": "Sauna finlandesa",
    "nameEn": "Finnish sauna",
    "category": "saunas",
    "tag": "Saunas",
    "tagEn": "Saunas",
    "image": wvAsset("assets/catalog/sauna-p3-0.jpeg"),
    "contain": false,
    "summary": "Cabina a medida con calefactor y piedras volcánicas.",
    "summaryEn": "Custom cabin with a heater and volcanic stones.",
    "features": [
      "Fabricación a medida",
      "Distribución, madera e iluminación según proyecto"
    ],
    "featuresEn": [
      "Made to measure",
      "Layout, wood and lighting to suit the project"
    ],
    "specs": {
      "Configuración": "Según proyecto",
      "Característica": "Fabricación a medida",
      "Detalle": "Distribución, madera e iluminación según proyecto"
    },
    "specsEn": {
      "Configuration": "Depends on the project",
      "Feature": "Made to measure",
      "Detail": "Layout, wood and lighting to suit the project"
    },
    "source": "Catálogo de saunas",
    "sourceEn": "Sauna catalogue",
    "page": 3,
    "diagram": false,
    "imageWidth": 640,
    "imageHeight": 427,
    "imageAlt": "Sauna finlandesa. Cabina a medida con calefactor y piedras volcánicas.",
    "imageAltEn": "Finnish sauna. Custom cabin with a heater and volcanic stones."
  },
  {
    "id": "wv-27",
    "name": "WV-27",
    "nameEn": "WV-27",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p11-native.png"),
    "contain": true,
    "summary": "Bañera todo en uno con enfriador y control integrados en el mueble.",
    "summaryEn": "All-in-one tub with chiller and controls built into the cabinet.",
    "features": [
      "Depósito de acero inoxidable 304",
      "Revestimiento de madera maciza",
      "Una plaza según catálogo"
    ],
    "featuresEn": [
      "304 stainless steel tank",
      "Solid wood cladding",
      "One person, per catalogue"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Depósito de acero inoxidable 304",
      "Detalle": "Revestimiento de madera maciza",
      "Equipamiento": "Una plaza según catálogo"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel tank",
      "Detail": "Solid wood cladding",
      "Equipment": "One person, per catalogue"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 11,
    "diagram": false,
    "imageWidth": 1448,
    "imageHeight": 1086,
    "imageAlt": "WV-27. Bañera todo en uno con enfriador y control integrados en el mueble.",
    "imageAltEn": "WV-27. All-in-one tub with chiller and controls built into the cabinet."
  },
  {
    "id": "wv-bed",
    "name": "WV Bed",
    "nameEn": "WV Bed",
    "category": "luz",
    "tag": "Fotobiomodulación",
    "tagEn": "Photobiomodulation",
    "image": wvAsset("assets/catalog/pbm-p14-0.jpeg"),
    "contain": false,
    "summary": "Cabina de fotobiomodulación de cuerpo completo.",
    "summaryEn": "Full-body photobiomodulation pod.",
    "features": [
      "Pantalla LCD táctil de 7 pulgadas",
      "Refrigeración activa integrada",
      "Dimensiones: 1.920 × 880 × 950 mm"
    ],
    "featuresEn": [
      "7-inch LCD touchscreen",
      "Built-in active cooling",
      "Dimensions: 1,920 × 880 × 950 mm"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Pantalla LCD táctil de 7 pulgadas",
      "Detalle": "Refrigeración activa integrada",
      "Dimensiones": "1.920 × 880 × 950 mm"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "7-inch LCD touchscreen",
      "Detail": "Built-in active cooling",
      "Dimensions": "1,920 × 880 × 950 mm"
    },
    "source": "Catálogo de fotobiomodulación",
    "sourceEn": "Photobiomodulation catalogue",
    "page": 14,
    "diagram": false,
    "imageWidth": 947,
    "imageHeight": 1263,
    "imageAlt": "WV Bed. Cabina de fotobiomodulación de cuerpo completo.",
    "imageAltEn": "WV Bed. Full-body photobiomodulation pod."
  },
  {
    "id": "exterior",
    "name": "Sauna de exterior",
    "nameEn": "Outdoor sauna",
    "category": "saunas",
    "tag": "Saunas",
    "tagEn": "Saunas",
    "image": wvAsset("assets/catalog/sauna-p3-2.jpeg"),
    "contain": false,
    "summary": "Proyecto a medida para jardín, terraza o junto a la piscina.",
    "summaryEn": "Custom project for a garden, terrace or poolside.",
    "features": [
      "Fabricación a medida",
      "Distribución, madera e iluminación según proyecto"
    ],
    "featuresEn": [
      "Made to measure",
      "Layout, wood and lighting to suit the project"
    ],
    "specs": {
      "Configuración": "Según proyecto",
      "Característica": "Fabricación a medida",
      "Detalle": "Distribución, madera e iluminación según proyecto"
    },
    "specsEn": {
      "Configuration": "Depends on the project",
      "Feature": "Made to measure",
      "Detail": "Layout, wood and lighting to suit the project"
    },
    "source": "Catálogo de saunas",
    "sourceEn": "Sauna catalogue",
    "page": 3,
    "diagram": false,
    "imageWidth": 568,
    "imageHeight": 640,
    "imageAlt": "Sauna de exterior. Proyecto a medida para jardín, terraza o junto a la piscina.",
    "imageAltEn": "Outdoor sauna. Custom project for a garden, terrace or poolside."
  },
  {
    "id": "wv-10",
    "name": "WV-10",
    "nameEn": "WV-10",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p3-native.jpeg"),
    "contain": true,
    "summary": "Bañera vertical con escalera exterior.",
    "summaryEn": "Upright tub with an external ladder.",
    "features": [
      "Depósito de acero inoxidable 304",
      "Acabado en cedro rojo",
      "Asiento interior"
    ],
    "featuresEn": [
      "304 stainless steel tank",
      "Red cedar finish",
      "Interior seat"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Depósito de acero inoxidable 304",
      "Detalle": "Acabado en cedro rojo",
      "Equipamiento": "Asiento interior"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel tank",
      "Detail": "Red cedar finish",
      "Equipment": "Interior seat"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 3,
    "diagram": false,
    "imageWidth": 898,
    "imageHeight": 1122,
    "imageAlt": "WV-10. Bañera vertical con escalera exterior.",
    "imageAltEn": "WV-10. Upright tub with an external ladder."
  },
  {
    "id": "vapor",
    "name": "Baños de vapor",
    "nameEn": "Steam rooms",
    "category": "accesorios",
    "tag": "Soluciones integrales",
    "tagEn": "Integrated solutions",
    "image": wvAsset("assets/catalog/vapor-native-rgb-v4.webp"),
    "contain": false,
    "summary": "Recintos a medida integrados en el diseño del proyecto.",
    "summaryEn": "Custom enclosures integrated into the project design.",
    "features": [
      "Acabados en mármol, microcemento, mosaico o piedra natural",
      "Bancos y respaldos ergonómicos"
    ],
    "featuresEn": [
      "Marble, microcement, mosaic or natural stone finishes",
      "Ergonomic benches and backrests"
    ],
    "specs": {
      "Configuración": "Según proyecto",
      "Característica": "Acabados en mármol, microcemento, mosaico o piedra natural",
      "Detalle": "Bancos y respaldos ergonómicos"
    },
    "specsEn": {
      "Configuration": "Depends on the project",
      "Feature": "Marble, microcement, mosaic or natural stone finishes",
      "Detail": "Ergonomic benches and backrests"
    },
    "source": "Catálogo general",
    "sourceEn": "General catalogue",
    "page": 24,
    "diagram": false,
    "imageSource": "Catálogo general",
    "imageSourceEn": "General catalogue",
    "imagePage": 24,
    "imageWidth": 1536,
    "imageHeight": 1024,
    "imageAlt": "Baños de vapor. Recintos a medida integrados en el diseño del proyecto.",
    "imageAltEn": "Steam rooms. Custom enclosures integrated into the project design."
  },
  {
    "id": "profesional",
    "name": "Sauna profesional",
    "nameEn": "Professional sauna",
    "category": "saunas",
    "tag": "Saunas",
    "tagEn": "Saunas",
    "image": wvAsset("assets/catalog/sauna-p3-3.jpeg"),
    "contain": false,
    "summary": "Diseño de gran formato para hoteles, spas y gimnasios.",
    "summaryEn": "Large-format design for hotels, spas and gyms.",
    "features": [
      "Fabricación a medida",
      "Distribución, madera e iluminación según proyecto"
    ],
    "featuresEn": [
      "Made to measure",
      "Layout, wood and lighting to suit the project"
    ],
    "specs": {
      "Configuración": "Según proyecto",
      "Característica": "Fabricación a medida",
      "Detalle": "Distribución, madera e iluminación según proyecto"
    },
    "specsEn": {
      "Configuration": "Depends on the project",
      "Feature": "Made to measure",
      "Detail": "Layout, wood and lighting to suit the project"
    },
    "source": "Catálogo de saunas",
    "sourceEn": "Sauna catalogue",
    "page": 3,
    "diagram": false,
    "imageWidth": 589,
    "imageHeight": 394,
    "imageAlt": "Sauna profesional. Diseño de gran formato para hoteles, spas y gimnasios.",
    "imageAltEn": "Professional sauna. Large-format design for hotels, spas and gyms."
  },
  {
    "id": "infrarrojos",
    "name": "Sauna de infrarrojos",
    "nameEn": "Infrared sauna",
    "category": "saunas",
    "tag": "Saunas",
    "tagEn": "Saunas",
    "image": wvAsset("assets/catalog/sauna-p10-0.jpeg"),
    "contain": false,
    "summary": "Cabina con emisores de infrarrojos de espectro completo.",
    "summaryEn": "Cabin with full-spectrum infrared emitters.",
    "features": [
      "Emisores IR-A, IR-B e IR-C",
      "Posibilidad de combinación con calefactor tradicional"
    ],
    "featuresEn": [
      "IR-A, IR-B and IR-C emitters",
      "Can be combined with a traditional heater"
    ],
    "specs": {
      "Configuración": "Según proyecto",
      "Característica": "Emisores IR-A, IR-B e IR-C",
      "Detalle": "Posibilidad de combinación con calefactor tradicional"
    },
    "specsEn": {
      "Configuration": "Depends on the project",
      "Feature": "IR-A, IR-B and IR-C emitters",
      "Detail": "Can be combined with a traditional heater"
    },
    "source": "Catálogo de saunas",
    "sourceEn": "Sauna catalogue",
    "page": 10,
    "diagram": false,
    "imageWidth": 532,
    "imageHeight": 800,
    "imageAlt": "Sauna de infrarrojos. Cabina con emisores de infrarrojos de espectro completo.",
    "imageAltEn": "Infrared sauna. Cabin with full-spectrum infrared emitters."
  },
  {
    "id": "wv-mat",
    "name": "WV Mat",
    "nameEn": "WV Mat",
    "category": "luz",
    "tag": "Fotobiomodulación",
    "tagEn": "Photobiomodulation",
    "image": wvAsset("assets/catalog/pbm-p9-0.jpeg"),
    "contain": false,
    "summary": "Alfombrilla de cuerpo completo para integrar sobre una camilla.",
    "summaryEn": "Full-body mat to place on a treatment bed.",
    "features": [
      "180 × 80 cm",
      "1.280 diodos",
      "Cinco niveles de brillo"
    ],
    "featuresEn": [
      "180 × 80 cm",
      "1,280 diodes",
      "Five brightness levels"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "180 × 80 cm",
      "Detalle": "1.280 diodos",
      "Equipamiento": "Cinco niveles de brillo"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "180 × 80 cm",
      "Detail": "1,280 diodes",
      "Equipment": "Five brightness levels"
    },
    "source": "Catálogo de fotobiomodulación",
    "sourceEn": "Photobiomodulation catalogue",
    "page": 9,
    "diagram": false,
    "imageWidth": 896,
    "imageHeight": 1344,
    "imageAlt": "WV Mat. Alfombrilla de cuerpo completo para integrar sobre una camilla.",
    "imageAltEn": "WV Mat. Full-body mat to place on a treatment bed."
  },
  {
    "id": "wv-mini-mat",
    "name": "WV Mini Mat",
    "nameEn": "WV Mini Mat",
    "category": "luz",
    "tag": "Fotobiomodulación",
    "tagEn": "Photobiomodulation",
    "image": wvAsset("assets/user/wv-mini-mat-user-v5.webp"),
    "contain": true,
    "summary": "Alfombrilla compacta y portátil para zonas concretas.",
    "summaryEn": "Compact, portable mat for specific areas.",
    "features": [
      "80 × 30 cm",
      "Banda extensora de 70 × 10 cm",
      "360 diodos"
    ],
    "featuresEn": [
      "80 × 30 cm",
      "70 × 10 cm extension strap",
      "360 diodes"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "80 × 30 cm",
      "Detalle": "Banda extensora de 70 × 10 cm",
      "Equipamiento": "360 diodos"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "80 × 30 cm",
      "Detail": "70 × 10 cm extension strap",
      "Equipment": "360 diodes"
    },
    "source": "Catálogo de fotobiomodulación",
    "sourceEn": "Photobiomodulation catalogue",
    "page": 11,
    "diagram": false,
    "imageWidth": 1254,
    "imageHeight": 1254,
    "imageSource": "Fotografía facilitada de WV Mini Mat",
    "imageSourceEn": "Supplied photograph of the WV Mini Mat",
    "imagePage": null,
    "imageAlt": "WV Mini Mat. Alfombrilla compacta y portátil para zonas concretas.",
    "imageAltEn": "WV Mini Mat. Compact, portable mat for specific areas."
  },
  {
    "id": "wv-mask",
    "name": "WV Mask",
    "nameEn": "WV Mask",
    "category": "luz",
    "tag": "Fotobiomodulación",
    "tagEn": "Photobiomodulation",
    "image": wvAsset("assets/catalog/pbm-p12-0.jpeg"),
    "contain": false,
    "summary": "Máscara facial inalámbrica con control de intensidad.",
    "summaryEn": "Wireless face mask with intensity control.",
    "features": [
      "236 diodos",
      "Tres niveles de intensidad",
      "Carga USB-C",
      "Dimensiones: 640 × 220 × 5,8 mm"
    ],
    "featuresEn": [
      "236 diodes",
      "Three intensity levels",
      "USB-C charging",
      "Dimensions: 640 × 220 × 5.8 mm"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "236 diodos",
      "Detalle": "Tres niveles de intensidad",
      "Equipamiento": "Carga USB-C",
      "Dimensiones": "640 × 220 × 5,8 mm"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "236 diodes",
      "Detail": "Three intensity levels",
      "Equipment": "USB-C charging",
      "Dimensions": "640 × 220 × 5.8 mm"
    },
    "source": "Catálogo de fotobiomodulación",
    "sourceEn": "Photobiomodulation catalogue",
    "page": 12,
    "diagram": false,
    "imageWidth": 895,
    "imageHeight": 1343,
    "imageAlt": "WV Mask. Máscara facial inalámbrica con control de intensidad.",
    "imageAltEn": "WV Mask. Wireless face mask with intensity control."
  },
  {
    "id": "wv-09",
    "name": "WV-09",
    "nameEn": "WV-09",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p2-native.png"),
    "contain": true,
    "summary": "Bañera de inmersión de formato ovalado con acabado en madera.",
    "summaryEn": "Oval ice bath with a wood finish.",
    "features": [
      "Depósito de acero inoxidable 304",
      "Cubierta y escalón de madera"
    ],
    "featuresEn": [
      "304 stainless steel tank",
      "Wooden cover and step"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Depósito de acero inoxidable 304",
      "Detalle": "Cubierta y escalón de madera"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel tank",
      "Detail": "Wooden cover and step"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 2,
    "diagram": false,
    "imageWidth": 1448,
    "imageHeight": 1086,
    "imageAlt": "WV-09. Bañera de inmersión de formato ovalado con acabado en madera.",
    "imageAltEn": "WV-09. Oval ice bath with a wood finish."
  },
  {
    "id": "wv-13",
    "name": "WV-13",
    "nameEn": "WV-13",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p4-native.jpeg"),
    "contain": true,
    "summary": "Bañera rectangular con mueble lateral para el enfriador.",
    "summaryEn": "Rectangular tub with a side cabinet for the chiller.",
    "features": [
      "Acero inoxidable 304 y cedro rojo",
      "Rejilla de ventilación lateral"
    ],
    "featuresEn": [
      "304 stainless steel and red cedar",
      "Side ventilation grille"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Acero inoxidable 304 y cedro rojo",
      "Detalle": "Rejilla de ventilación lateral"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel and red cedar",
      "Detail": "Side ventilation grille"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 4,
    "diagram": false,
    "imageWidth": 1420,
    "imageHeight": 710,
    "imageAlt": "WV-13. Bañera rectangular con mueble lateral para el enfriador.",
    "imageAltEn": "WV-13. Rectangular tub with a side cabinet for the chiller."
  },
  {
    "id": "wv-15",
    "name": "WV-15",
    "nameEn": "WV-15",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p5-native.png"),
    "contain": true,
    "summary": "Bañera vertical con escalera y plataforma de acceso.",
    "summaryEn": "Upright tub with a ladder and access platform.",
    "features": [
      "Acero inoxidable 304 y cedro rojo",
      "Cubierta"
    ],
    "featuresEn": [
      "304 stainless steel and red cedar",
      "Cover"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Acero inoxidable 304 y cedro rojo",
      "Detalle": "Cubierta"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel and red cedar",
      "Detail": "Cover"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 5,
    "diagram": false,
    "imageWidth": 1536,
    "imageHeight": 1024,
    "imageAlt": "WV-15. Bañera vertical con escalera y plataforma de acceso.",
    "imageAltEn": "WV-15. Upright tub with a ladder and access platform."
  },
  {
    "id": "wv-16",
    "name": "WV-16",
    "nameEn": "WV-16",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p6-native.jpeg"),
    "contain": true,
    "summary": "Bañera ovalada con escalera y panel de control.",
    "summaryEn": "Oval tub with a ladder and control panel.",
    "features": [
      "Acero inoxidable 304 y cedro rojo",
      "Control de temperatura",
      "Cubierta"
    ],
    "featuresEn": [
      "304 stainless steel and red cedar",
      "Temperature control",
      "Cover"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Acero inoxidable 304 y cedro rojo",
      "Detalle": "Control de temperatura",
      "Equipamiento": "Cubierta"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel and red cedar",
      "Detail": "Temperature control",
      "Equipment": "Cover"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 6,
    "diagram": false,
    "imageWidth": 1383,
    "imageHeight": 922,
    "imageAlt": "WV-16. Bañera ovalada con escalera y panel de control.",
    "imageAltEn": "WV-16. Oval tub with a ladder and control panel."
  },
  {
    "id": "wv-17",
    "name": "WV-17",
    "nameEn": "WV-17",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p7-native.png"),
    "contain": true,
    "summary": "Bañera rectangular con mueble de acabado oscuro.",
    "summaryEn": "Rectangular tub with a dark-finish cabinet.",
    "features": [
      "Rejilla de ventilación",
      "Cubierta y escalón"
    ],
    "featuresEn": [
      "Ventilation grille",
      "Cover and step"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Rejilla de ventilación",
      "Detalle": "Cubierta y escalón"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "Ventilation grille",
      "Detail": "Cover and step"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 7,
    "diagram": false,
    "imageWidth": 1448,
    "imageHeight": 1086,
    "imageAlt": "WV-17. Bañera rectangular con mueble de acabado oscuro.",
    "imageAltEn": "WV-17. Rectangular tub with a dark-finish cabinet."
  },
  {
    "id": "wv-18",
    "name": "WV-18",
    "nameEn": "WV-18",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p8-native.png"),
    "contain": true,
    "summary": "Bañera rectangular con control integrado e iluminación interior.",
    "summaryEn": "Rectangular tub with built-in controls and interior lighting.",
    "features": [
      "Depósito de acero inoxidable 304",
      "Panel de control",
      "Luz interior"
    ],
    "featuresEn": [
      "304 stainless steel tank",
      "Control panel",
      "Interior light"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Depósito de acero inoxidable 304",
      "Detalle": "Panel de control",
      "Equipamiento": "Luz interior"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel tank",
      "Detail": "Control panel",
      "Equipment": "Interior light"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 8,
    "diagram": false,
    "imageWidth": 1448,
    "imageHeight": 1086,
    "imageAlt": "WV-18. Bañera rectangular con control integrado e iluminación interior.",
    "imageAltEn": "WV-18. Rectangular tub with built-in controls and interior lighting."
  },
  {
    "id": "wv-20",
    "name": "WV-20",
    "nameEn": "WV-20",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p9-native.png"),
    "contain": true,
    "summary": "Bañera ovalada con acabado en abeto.",
    "summaryEn": "Oval tub with a fir finish.",
    "features": [
      "Acero inoxidable 304 y abeto",
      "Cubierta"
    ],
    "featuresEn": [
      "304 stainless steel and fir",
      "Cover"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Acero inoxidable 304 y abeto",
      "Detalle": "Cubierta"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel and fir",
      "Detail": "Cover"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 9,
    "diagram": false,
    "imageWidth": 1448,
    "imageHeight": 1086,
    "imageAlt": "WV-20. Bañera ovalada con acabado en abeto.",
    "imageAltEn": "WV-20. Oval tub with a fir finish."
  },
  {
    "id": "wv-22",
    "name": "WV-22",
    "nameEn": "WV-22",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p10-native.jpeg"),
    "contain": true,
    "summary": "Bañera rectangular con panel de control y escalones.",
    "summaryEn": "Rectangular tub with a control panel and steps.",
    "features": [
      "Acero inoxidable 304 y tsuga",
      "Cubierta"
    ],
    "featuresEn": [
      "304 stainless steel and hemlock",
      "Cover"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Acero inoxidable 304 y tsuga",
      "Detalle": "Cubierta"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel and hemlock",
      "Detail": "Cover"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 10,
    "diagram": false,
    "imageWidth": 1304,
    "imageHeight": 978,
    "imageAlt": "WV-22. Bañera rectangular con panel de control y escalones.",
    "imageAltEn": "WV-22. Rectangular tub with a control panel and steps."
  },
  {
    "id": "wv-29",
    "name": "WV-29",
    "nameEn": "WV-29",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p12-native.jpeg"),
    "contain": true,
    "summary": "Bañera todo en uno con ventilación lateral y control frontal.",
    "summaryEn": "All-in-one tub with side ventilation and front controls.",
    "features": [
      "Depósito de acero inoxidable 304",
      "Faldón de madera",
      "Una plaza según catálogo"
    ],
    "featuresEn": [
      "304 stainless steel tank",
      "Wooden skirt",
      "One person, per catalogue"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Característica": "Depósito de acero inoxidable 304",
      "Detalle": "Faldón de madera",
      "Equipamiento": "Una plaza según catálogo"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Feature": "304 stainless steel tank",
      "Detail": "Wooden skirt",
      "Equipment": "One person, per catalogue"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 12,
    "diagram": false,
    "imageWidth": 1383,
    "imageHeight": 922,
    "imageAlt": "WV-29. Bañera todo en uno con ventilación lateral y control frontal.",
    "imageAltEn": "WV-29. All-in-one tub with side ventilation and front controls."
  },
  {
    "id": "wv-30",
    "name": "WV-30",
    "nameEn": "WV-30",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p13-native.png"),
    "contain": true,
    "summary": "Bañera de formato XL con grupo de frío integrado.",
    "summaryEn": "XL tub with a built-in chiller unit.",
    "features": [
      "Longitud exterior declarada: 292 cm",
      "Dos plazas según catálogo"
    ],
    "featuresEn": [
      "Stated external length: 292 cm",
      "Two people, per catalogue"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Longitud exterior declarada": "292 cm",
      "Detalle": "Dos plazas según catálogo"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Stated external length": "292 cm",
      "Detail": "Two people, per catalogue"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 13,
    "diagram": false,
    "imageWidth": 1448,
    "imageHeight": 1086,
    "imageAlt": "WV-30. Bañera de formato XL con grupo de frío integrado.",
    "imageAltEn": "WV-30. XL tub with a built-in chiller unit."
  },
  {
    "id": "wv-31",
    "name": "WV-31",
    "nameEn": "WV-31",
    "category": "banos",
    "tag": "Baños de inmersión",
    "tagEn": "Ice baths",
    "image": wvAsset("assets/catalog/cold-p14-native.jpeg"),
    "contain": true,
    "summary": "Bañera XL con acabado de madera oscura.",
    "summaryEn": "XL tub with a dark wood finish.",
    "features": [
      "Longitud exterior declarada: 292 cm",
      "Cuatro plazas según catálogo"
    ],
    "featuresEn": [
      "Stated external length: 292 cm",
      "Four people, per catalogue"
    ],
    "specs": {
      "Configuración": "A confirmar en la propuesta",
      "Longitud exterior declarada": "292 cm",
      "Detalle": "Cuatro plazas según catálogo"
    },
    "specsEn": {
      "Configuration": "To be confirmed in the proposal",
      "Stated external length": "292 cm",
      "Detail": "Four people, per catalogue"
    },
    "source": "Catálogo de baños de inmersión",
    "sourceEn": "Ice bath catalogue",
    "page": 14,
    "diagram": false,
    "imageWidth": 1420,
    "imageHeight": 710,
    "imageAlt": "WV-31. Bañera XL con acabado de madera oscura.",
    "imageAltEn": "WV-31. XL tub with a dark wood finish."
  },
  {
    "id": "piscinas",
    "name": "Piscinas modulares",
    "nameEn": "Modular pools",
    "category": "accesorios",
    "tag": "Soluciones integrales",
    "tagEn": "Integrated solutions",
    "image": wvAsset("assets/catalog/general-p26-1-rgb-v4.webp"),
    "contain": false,
    "summary": "Soluciones de inmersión y contraste dimensionadas para cada espacio.",
    "summaryEn": "Immersion and contrast solutions sized for each space.",
    "features": [
      "Construcciones en acero inoxidable, madera o acrílico",
      "Volumen, accesos y zona técnica según proyecto"
    ],
    "featuresEn": [
      "Stainless steel, wood or acrylic construction",
      "Volume, access and technical area to suit the project"
    ],
    "specs": {
      "Configuración": "Según proyecto",
      "Característica": "Construcciones en acero inoxidable, madera o acrílico",
      "Detalle": "Volumen, accesos y zona técnica según proyecto"
    },
    "specsEn": {
      "Configuration": "Depends on the project",
      "Feature": "Stainless steel, wood or acrylic construction",
      "Detail": "Volume, access and technical area to suit the project"
    },
    "source": "Catálogo general",
    "sourceEn": "General catalogue",
    "page": 26,
    "diagram": false,
    "imageWidth": 410,
    "imageHeight": 410,
    "imageAlt": "Piscinas modulares. Soluciones de inmersión y contraste dimensionadas para cada espacio.",
    "imageAltEn": "Modular pools. Immersion and contrast solutions sized for each space."
  },
  {
    "id": "hiperbaricas",
    "name": "Cámaras hiperbáricas",
    "nameEn": "Hyperbaric chambers",
    "category": "accesorios",
    "tag": "Soluciones integrales",
    "tagEn": "Integrated solutions",
    "image": wvAsset("assets/catalog/general-p31-0-rgb-v4.webp"),
    "contain": false,
    "summary": "Selección e integración de cámaras según las necesidades del proyecto.",
    "summaryEn": "Selection and integration of chambers to suit the project's needs.",
    "features": [
      "Modelo, ventilación y espacio técnico por definir",
      "Requisitos de operación sujetos a validación técnica"
    ],
    "featuresEn": [
      "Model, ventilation and technical space to be defined",
      "Operating requirements subject to technical validation"
    ],
    "specs": {
      "Configuración": "Según proyecto",
      "Característica": "Modelo, ventilación y espacio técnico por definir",
      "Detalle": "Requisitos de operación sujetos a validación técnica"
    },
    "specsEn": {
      "Configuration": "Depends on the project",
      "Feature": "Model, ventilation and technical space to be defined",
      "Detail": "Operating requirements subject to technical validation"
    },
    "source": "Catálogo general",
    "sourceEn": "General catalogue",
    "page": 31,
    "diagram": false,
    "imageWidth": 741,
    "imageHeight": 581,
    "imageAlt": "Cámaras hiperbáricas. Selección e integración de cámaras según las necesidades del proyecto.",
    "imageAltEn": "Hyperbaric chambers. Selection and integration of chambers to suit the project's needs."
  },
  {
    "id": "fitness",
    "name": "Zona de entrenamiento",
    "nameEn": "Training area",
    "category": "accesorios",
    "tag": "Soluciones integrales",
    "tagEn": "Integrated solutions",
    "image": wvAsset("assets/catalog/fitness-native-rgb-v4.webp"),
    "contain": false,
    "summary": "Equipamiento de entrenamiento coordinado con la zona de bienestar.",
    "summaryEn": "Training equipment coordinated with the wellness area.",
    "features": [
      "Cardio y fuerza",
      "Pilates, yoga y barre",
      "Entrenamiento funcional",
      "Pavimentos y espejos técnicos"
    ],
    "featuresEn": [
      "Cardio and strength",
      "Pilates, yoga and barre",
      "Functional training",
      "Technical flooring and mirrors"
    ],
    "specs": {
      "Configuración": "Según proyecto",
      "Característica": "Cardio y fuerza",
      "Detalle": "Pilates, yoga y barre",
      "Equipamiento": "Entrenamiento funcional",
      "Complemento": "Pavimentos y espejos técnicos"
    },
    "specsEn": {
      "Configuration": "Depends on the project",
      "Feature": "Cardio and strength",
      "Detail": "Pilates, yoga and barre",
      "Equipment": "Functional training",
      "Extra": "Technical flooring and mirrors"
    },
    "source": "Catálogo general",
    "sourceEn": "General catalogue",
    "page": 32,
    "diagram": false,
    "imageSource": "Catálogo general",
    "imageSourceEn": "General catalogue",
    "imagePage": 32,
    "imageWidth": 1200,
    "imageHeight": 833,
    "imageAlt": "Zona de entrenamiento. Equipamiento de entrenamiento coordinado con la zona de bienestar.",
    "imageAltEn": "Training area. Training equipment coordinated with the wellness area."
  }
];

'use strict';
const $ = (s) => root.querySelector(s);
const menu = $('.menu');
function syncMenuLabel(){const open=menu.getAttribute('aria-expanded')==='true';menu.setAttribute('aria-label',window.WV_LANG==='en'?(open?'Close menu':'Open menu'):(open?'Cerrar menú':'Abrir menú'))}
menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));syncMenuLabel();$('#navigation').classList.toggle('open',open)});
syncMenuLabel();window.addEventListener('wv-language-change',syncMenuLabel);
$('#navigation').querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{menu.setAttribute('aria-expanded','false');syncMenuLabel();$('#navigation').classList.remove('open')}));
root.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.setAttribute('aria-expanded','false');syncMenuLabel();$('#navigation').classList.remove('open')}});
const solutions={sauna:{image:wvAsset("assets/catalog/sauna-premium-native-rgb-v4.webp"),alt:'Sauna de madera integrada a medida',altEn:'Custom integrated wood sauna',chip:'LA CALIDEZ, HECHA ESPACIO.',chipEn:'WARMTH MADE SPACE.',symbol:'≋',label:'SAUNAS A MEDIDA',labelEn:'CUSTOM SAUNAS',title:'El arte<br>de bajar el ritmo.',titleEn:'The art<br>of slowing down.',copy:'Madera, luz y calor en una composición que encaja con tu proyecto. Saunas tradicionales, de infrarrojos y cabinas modulares para interior o exterior.',copyEn:'Wood, light and heat composed to fit your project. Traditional and infrared saunas and modular cabins for indoors or out.',features:['Integración a medida','Selección de materiales y acabados','Instalación y acompañamiento'],featuresEn:['Custom integration','Material and finish selection','Installation and support'],cta:'Diseñemos tu sauna',ctaEn:'Design your sauna',path:'saunas',choice:'Sauna a medida',choiceEn:'Custom sauna'},ice:{image:wvAsset("assets/user/inmersion-interior-user-v6.jpg"),alt:'Baños de inmersión en un espacio interior, imagen facilitada',altEn:'Ice baths in an interior space, supplied image',chip:'EL PODER DEL CONTRASTE.',chipEn:'THE POWER OF CONTRAST.',symbol:'❋',label:'BAÑOS DE INMERSIÓN',labelEn:'ICE BATHS',title:'Una pausa.<br>Otra energía.',titleEn:'A pause.<br>Fresh energy.',copy:'El frío como parte de una experiencia de contraste. Baños de inmersión que se integran en zonas de spa y recuperación, con una selección adaptada a las necesidades de tu espacio.',copyEn:'Cold as part of contrast therapy. Ice baths integrated into spa and recovery zones, selected for how your space will be used.',features:['Integración con la zona de calor','Selección según el uso previsto','Configuración sujeta al proyecto'],featuresEn:['Pairs with heat zones','Selected for intended use','Configuration per project'],cta:'Explorar el frío',ctaEn:'Explore cold',path:'soluciones-profesionales',choice:'Baño de inmersión',choiceEn:'Ice bath'},light:{image:wvAsset("assets/catalog/pbm-p6-0.jpeg"),alt:'Equipo de luz roja de Wellness Vision en uso',altEn:'Wellness Vision red light equipment in use',chip:'TECNOLOGÍA QUE ENCUENTRA SU LUGAR.',chipEn:'TECHNOLOGY THAT FINDS ITS PLACE.',symbol:'☼',label:'LUZ ROJA & INFRARROJA',labelEn:'RED & NEAR-INFRARED LIGHT',title:'Una nueva luz<br>para tu espacio.',titleEn:'A new light<br>for your space.',copy:'Equipos de fotobiomodulación en diferentes formatos. Una solución que se puede incorporar a tu propuesta de bienestar, con la configuración y el uso definidos para cada proyecto.',copyEn:'Photobiomodulation equipment in multiple formats. A solution you can fold into your wellness offer, with use and setup defined per project.',features:['Paneles y formatos profesionales','Integración en zonas de recuperación','Acompañamiento para la puesta en uso'],featuresEn:['Professional panels and formats','Recovery zone integration','Support for rollout'],cta:'Hablemos de luz',ctaEn:'Talk about light',path:'fotobiomodulacion',choice:'Luz roja',choiceEn:'Red light'}};
const en=()=>window.WV_LANG==='en';
const tx=(es,enText)=>en()?enText:es;
const VALUE_EN={'Hotel o alojamiento':'Hotel or stay','Gimnasio o club':'Gym or club','Centro de recuperación':'Recovery centre','Otro espacio':'Other space','Sauna a medida':'Custom sauna','Baño de inmersión':'Ice bath','Luz roja':'Red light','Espacio completo':'Complete space','Interior':'Indoor','Exterior':'Outdoor','Por definir':'To be defined','LED cálida':'Warm LED','Abeto':'Fir','Ayous alistonado':'Slatted ayous','Barnizado ecológico':'Eco varnish','Panelado horizontal':'Horizontal panelling'};
const vEn=v=>en()&&VALUE_EN[v]?VALUE_EN[v]:v;
const pName=p=>en()&&p.nameEn?p.nameEn:p.name;
const pSummary=p=>en()&&p.summaryEn?p.summaryEn:p.summary;
const pFeatures=p=>en()&&p.featuresEn?p.featuresEn:p.features;
const pSpecs=p=>en()&&p.specsEn?p.specsEn:p.specs;
const pSource=p=>en()&&p.sourceEn?p.sourceEn:p.source;
const pImageSource=p=>p.imageSource?(en()&&p.imageSourceEn?p.imageSourceEn:p.imageSource):pSource(p);
const pAlt=p=>en()?(p.imageAltEn||pName(p)+' · catalogue photo'):(p.imageAlt||p.name+' · fotografía de catálogo');
function solutionCopy(s,k,ek){return en()&&s[ek]!=null?s[ek]:s[k];}
let activeSolution='sauna';
function activateSolution(key){activeSolution=key;const s=solutions[key];root.querySelectorAll('[data-solution]').forEach(b=>{const on=b.dataset.solution===key;b.setAttribute('aria-selected',String(on));b.tabIndex=on?0:-1});$('#solution-panel').setAttribute('aria-labelledby','tab-'+key);$('#solution-image').src=s.image;$('#solution-image').alt=solutionCopy(s,'alt','altEn');$('#solution-chip').textContent=solutionCopy(s,'chip','chipEn');$('#solution-symbol').textContent=s.symbol;$('#solution-label').textContent=solutionCopy(s,'label','labelEn');$('#solution-title').innerHTML=solutionCopy(s,'title','titleEn');$('#solution-copy').textContent=solutionCopy(s,'copy','copyEn');$('#solution-features').replaceChildren(...(en()?s.featuresEn:s.features).map(f=>{const li=document.createElement('li');li.textContent=f;return li}));$('#solution-cta').innerHTML=solutionCopy(s,'cta','ctaEn')+' <span>↗</span>';$('#solution-source').href='#catalogo';$('#solution-source').dataset.catalogCategory=({sauna:'saunas',ice:'banos',light:'luz'})[key];}
root.querySelectorAll('[data-solution]').forEach(b=>b.addEventListener('click',()=>activateSolution(b.dataset.solution)));
$('#solution-cta').addEventListener('click',()=>{root.querySelectorAll('[name=solution]').forEach(i=>{if(i.value===solutions[activeSolution].choice)i.checked=true})});
const sectors={hotel:{caption:'EL BIENESTAR COMO DESTINO',captionEn:'WELLBEING AS DESTINATION',copy:'Una invitación a quedarse un poco más. Explora un spa íntimo, una suite con sauna o un circuito de contraste que dialogue con la arquitectura de tu hotel.',copyEn:'An invitation to stay a little longer. Explore an intimate spa, a suite with sauna, or a contrast circuit that fits your hotel architecture.',choice:'Hotel o alojamiento',choiceEn:'Hotel or stay'},fitness:{caption:'EL SIGUIENTE ESPACIO DE TU CLUB',captionEn:'YOUR CLUB\'S NEXT SPACE',copy:'El entrenamiento también merece una pausa. Imagina una zona de recuperación que acompañe el recorrido de tus socios, con soluciones elegidas según el uso y el espacio disponible.',copyEn:'Training deserves a pause too. Imagine a recovery zone along your members\' journey, with solutions chosen for use and space.',choice:'Gimnasio o club',choiceEn:'Gym or club'},recovery:{caption:'CADA DETALLE, CON UNA FUNCIÓN',captionEn:'EVERY DETAIL WITH A PURPOSE',copy:'Un entorno pensado alrededor de la experiencia de cada persona. Explora cómo combinar calor, frío y luz en un espacio de recuperación con un recorrido claro y una operación coherente.',copyEn:'An environment built around each person\'s experience. Explore heat, cold and light in a recovery space with a clear flow.',choice:'Centro de recuperación',choiceEn:'Recovery centre'}};
function sectorCopy(s,k,ek){return en()&&s[ek]!=null?s[ek]:s[k];}
let activeSector='hotel';
function activateSector(key){activeSector=key;const s=sectors[key];root.querySelectorAll('[data-sector]').forEach(b=>{const on=b.dataset.sector===key;b.setAttribute('aria-selected',String(on));b.tabIndex=on?0:-1});$('#sector-detail').setAttribute('aria-labelledby','sector-'+key);$('#sector-caption').textContent=sectorCopy(s,'caption','captionEn');$('#sector-copy').textContent=sectorCopy(s,'copy','copyEn');}
root.querySelectorAll('[data-sector]').forEach(b=>b.addEventListener('click',()=>activateSector(b.dataset.sector)));
$('#sector-cta').addEventListener('click',()=>{root.querySelectorAll('[name=space]').forEach(i=>i.checked=i.value===sectors[activeSector].choice)});
root.querySelectorAll('[role=tablist]').forEach(list=>list.addEventListener('keydown',e=>{const tabs=[...list.querySelectorAll('[role=tab]')];let index=tabs.indexOf(document.activeElement);if(index<0)return;if(e.key==='ArrowRight'||e.key==='ArrowDown')index=(index+1)%tabs.length;else if(e.key==='ArrowLeft'||e.key==='ArrowUp')index=(index+tabs.length-1)%tabs.length;else if(e.key==='Home')index=0;else if(e.key==='End')index=tabs.length-1;else return;e.preventDefault();tabs[index].click();tabs[index].focus()}));
const dialog=$('#brief-dialog');
$('#brief-form').addEventListener('submit',e=>{e.preventDefault();const data=new FormData(e.currentTarget);const choices=data.getAll('solution');const privateFields=[];const protect=value=>{const index=privateFields.push(value)-1;return '\uE000'+index+'\uE001'};const field=k=>String(data.get(k)||'').trim();const sourceText=tx('Hola, equipo de Wellness Vision:\n\nMe gustaría solicitar información para este proyecto.','Hello Wellness Vision team,\n\nI would like to request information about this project.')+'\n\n'+tx('Tipo de espacio','Type of space')+': '+vEn(data.get('space'))+'\n'+tx('Ubicación','Location')+': '+(field('location')?protect(field('location')):tx('Por definir','To be defined'))+'\n'+tx('Nombre o contacto','Name or contact')+': '+(field('contact')?protect(field('contact')):tx('No indicado','Not provided'))+'\n'+tx('Soluciones de interés','Solutions of interest')+': '+(choices.length?choices.map(vEn).join(', '):tx('Por definir con vuestro equipo','To be defined with your team'))+'\n\n'+tx('Productos y cantidades','Products and quantities')+':\n'+(wv.getProjectProductNames?wv.getProjectProductNames():tx('Sin modelos concretos todavía','No specific models yet'))+'\n\n'+tx('Configuración de saunas','Sauna configuration')+':\n'+(wv.getSaunaConfigurationSummary?wv.getSaunaConfigurationSummary():tx('Sin configuración a medida todavía','No custom configuration yet'))+'\n\n'+tx('Sobre el proyecto','About the project')+':\n'+(field('details')?protect(field('details')):tx('Me gustaría definir los detalles en una primera conversación.','I would like to go over the details in a first conversation.'))+'\n\n'+tx('Las dimensiones y capacidades son orientativas y requieren validación del fabricante.\nGracias.','Dimensions and capacities are indicative and require validation by the manufacturer.\nThank you.');let text=sourceText;privateFields.forEach((value,index)=>{text=text.split('\uE000'+index+'\uE001').join(value)});$('#brief-output').value=text;$('#whatsapp-brief').href='https://wa.me/34614740654?text='+encodeURIComponent(text);$('#copy-status').textContent=tx('No se ha enviado nada. Revisa el borrador en WhatsApp antes de enviarlo a +34 614 74 06 54.','Nothing has been sent. Review the draft in WhatsApp before sending it to +34 614 74 06 54.');$('#copy-brief').textContent=tx('Copiar resumen','Copy summary');dialog.showModal()});
$('.dialog-close').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
$('#copy-brief').addEventListener('click',async()=>{try{await navigator.clipboard.writeText($('#brief-output').value);$('#copy-status').textContent=tx('Resumen copiado. Puedes pegarlo en WhatsApp; todavía no se ha enviado.','Summary copied. You can paste it into WhatsApp; nothing has been sent yet.');$('#copy-brief').textContent=tx('Copiado ✓','Copied ✓')}catch{$('#brief-output').focus();$('#brief-output').select();$('#copy-status').textContent=tx('Selecciona y copia el resumen manualmente. No se ha enviado nada.','Select and copy the summary manually. Nothing has been sent.')}});

'use strict';
(()=>{
const q=s=>root.querySelector(s), qa=s=>[...root.querySelectorAll(s)];
const products=wv.WV_CATALOG||[], byId=new Map(products.map(p=>[p.id,p]));if(!window.WV_CATALOG)window.WV_CATALOG=products;
const compare=new Set(), project=new Set(), configurations=new Map(), quantities=new Map();
let category='all', query='', step=0, openProductId=null, toastTimer;
const labels={saunas:'Saunas',banos:'Baños de inmersión',luz:'Luz roja',accesorios:'Soluciones integrales'};
const labelsEn={saunas:'Saunas',banos:'Ice baths',luz:'Red light',accesorios:'Integrated solutions'};
const intros={saunas:['Calor a tu medida.','Cinco familias para explorar materiales, formatos y formas de integrar el calor. Cada sauna se concreta según el proyecto.'],banos:['Tu forma de vivir el frío.','Catorce modelos, desde formatos verticales hasta bañeras de gran tamaño. Compara acabados, acceso y equipamiento.'],luz:['La luz, en cinco formatos.','Panel, alfombrillas, máscara y cabina. Consulta las diferencias de formato y los datos verificados de cada equipo.'],accesorios:['Una visión más completa.','Vapor, piscinas, cámaras hiperbáricas y entrenamiento. Soluciones del catálogo general que se estudian e integran por proyecto.']};
const introsEn={saunas:['Heat tailored to you.','Five families to explore materials, formats and ways to integrate heat. Each sauna is shaped to the project.'],banos:['Your way to live the cold.','Fourteen models from vertical tubs to large-format baths. Compare finishes, access and equipment.'],luz:['Light in five formats.','Panel, mats, mask and cabin. Compare formats and verified specs for each device.'],accesorios:['A fuller vision.','Steam, pools, hyperbaric chambers and training. General-catalog solutions scoped and integrated per project.']};
function catLabels(){return en()?labelsEn:labels;}
function catIntros(){return en()?introsEn:intros;}
const escape=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const norm=s=>String(s).toLocaleLowerCase('es').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
const buttonProject=p=>project.has(p.id)?(en()?'Added to project ✓':'Añadido al proyecto ✓'):(en()?'Add to project +':'Añadir al proyecto +');
function toast(text){q('#site-toast').textContent=text;q('#site-toast').classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>q('#site-toast').classList.remove('show'),3000)}
function media(p,classes='',lazy=true){return p.image?`<img class="${classes}" src="${escape(p.image)}" width="${p.imageWidth||''}" height="${p.imageHeight||''}" decoding="async" alt="${escape(pAlt(p))}" ${lazy?'loading="lazy"':''}>`:`<div class="no-product-photo ${classes}"><span>WV</span><strong>${escape(pName(p))}</strong><small>${tx('Sin fotografía específica en el catálogo','No specific catalogue photo')}</small></div>`}
function card(p){const L=catLabels();const eyebrow=p.category==='saunas'?(en()?'CUSTOM DESIGN':'DISEÑO A MEDIDA'):p.category==='accesorios'?(en()?'PROJECT INTEGRATION':'INTEGRACIÓN POR PROYECTO'):pName(p);const cmp=compare.has(p.id)?(en()?'In compare':'En comparativa'):(en()?'Compare':'Comparar');const tagMax=window.matchMedia&&window.matchMedia('(max-width:760px)').matches?36:48;const tagSlice=tagMax-3;return `<article class="product-card" data-product-card="${escape(p.id)}"><button type="button" class="product-open" data-open-product="${escape(p.id)}" aria-label="${en()?'View':'Ver ficha de'} ${escape(pName(p))}"><div class="product-image ${p.contain?'contain':''}">${media(p)}<span class="product-category">${escape(L[p.category])}</span><span class="open-arrow" aria-hidden="true">↗</span></div><div class="product-text"><span class="eyebrow">${escape(eyebrow)}</span><h4>${escape(pName(p))}</h4><p>${escape(pSummary(p))}</p><div class="product-tags">${pFeatures(p).slice(0,window.matchMedia&&window.matchMedia('(max-width:760px)').matches?1:2).map(f=>`<span>${escape(f.length>tagMax?f.slice(0,tagSlice)+'…':f)}</span>`).join('')}</div></div></button><div class="product-actions"><button type="button" class="compare-toggle" data-compare="${escape(p.id)}" aria-pressed="${compare.has(p.id)}">${cmp}</button><button type="button" class="project-toggle" data-project="${escape(p.id)}" aria-pressed="${project.has(p.id)}">${buttonProject(p)}</button></div></article>`}
function renderCatalog(){const filtered=products.filter(p=>norm([p.name,p.nameEn,p.summary,p.summaryEn,p.tag,p.tagEn,...p.features,...(p.featuresEn||[])].filter(Boolean).join(' ')).includes(norm(query)));const L=catLabels();const I=catIntros();const sol=en()?'SOLUTION':'SOLUCIÓN';const sols=en()?'SOLUTIONS':'SOLUCIONES';q('#product-grid').innerHTML=Object.keys(L).map((key,index)=>{const list=filtered.filter(p=>p.category===key);return list.length?`<section class="catalog-category-section" id="categoria-${key}" aria-labelledby="heading-${key}"><div class="catalog-group-heading"><div><span class="eyebrow">${String(index+1).padStart(2,'0')} / ${list.length} ${list.length===1?sol:sols}</span><h3 id="heading-${key}">${escape(L[key])}</h3><p>${escape(I[key][1])}</p></div>${key==='saunas'?`<a class="text-link" href="#configurador-sauna">${en()?'Configure a custom sauna':'Configurar una sauna a medida'} <span>↗</span></a>`:''}</div><div class="category-product-grid">${list.map(card).join('')}</div></section>`:''}).join('');q('#catalog-count').textContent=filtered.length?(en()?`${filtered.length} models and solutions · by category`:`${filtered.length} modelos y soluciones · organizados por categoría`):(en()?'No results':'Ningún resultado');q('#catalog-empty').hidden=!!filtered.length;q('#total-products').textContent=products.length;qa('[data-category]').forEach(b=>{const on=b.dataset.category===category;b.classList.toggle('active',on);b.setAttribute('aria-pressed',String(on))});window.dispatchEvent(new Event('wv-catalog-rendered'));}
function setCategory(key){category=key;query='';q('#catalog-search').value='';renderCatalog();const target=q(key==='all'?'#catalogo':'#categoria-'+key);if(target&&target.scrollIntoView)target.scrollIntoView({behavior:window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})}
window.addEventListener('wv-language-change',()=>{renderCatalog();refreshToggles();renderCompareBar();renderProject();if(q('#comparison-dialog').open)renderComparison();if(openInfoKey&&q('#info-dialog').open)openInfo(openInfoKey);activateSolution(activeSolution);activateSector(activeSector);if(window.WV_I18N){window.WV_I18N.applyNative(root);requestAnimationFrame(window.WV_I18N.refreshWeglot);}if(openProductId&&q('#product-dialog')&&q('#product-dialog').open)openProduct(openProductId);});
qa('[data-category]').forEach(b=>b.addEventListener('click',()=>setCategory(b.dataset.category)));
q('#catalog-search').addEventListener('input',e=>{query=e.target.value;renderCatalog()});q('#reset-filters').addEventListener('click',()=>setCategory('all'));
q('#solution-source').addEventListener('click',e=>{e.preventDefault();setCategory(q('#solution-source').dataset.catalogCategory||'saunas')});
function refreshToggles(){qa('[data-compare]').forEach(b=>{const selected=compare.has(b.dataset.compare);b.setAttribute('aria-pressed',String(selected));if(b.classList.contains('compare-toggle'))b.textContent=selected?(en()?'In compare':'En comparativa'):(en()?'Compare':'Comparar');else b.textContent=selected?(en()?'Remove from compare':'Quitar de comparativa'):(en()?'Compare this model':'Comparar este modelo')});qa('[data-project]').forEach(b=>{const p=byId.get(b.dataset.project);if(!p)return;b.setAttribute('aria-pressed',String(project.has(p.id)));b.textContent=buttonProject(p)})}
function toggleCompare(id){if(!byId.has(id))return;if(compare.has(id))compare.delete(id);else{if(compare.size>=3){toast(tx('Puedes comparar hasta tres opciones. Retira una para añadir otra.','You can compare up to three options. Remove one to add another.'));return}compare.add(id)}refreshToggles();renderCompareBar();if(q('#comparison-dialog').open)renderComparison();}
function renderCompareBar(){q('#compare-bar').hidden=compare.size===0;q('#open-comparison').disabled=compare.size<2;q('#compare-names').textContent=[...compare].map(id=>pName(byId.get(id))).join(' · ');q('#compare-total').textContent=`${compare.size}/3`;q('#open-comparison').setAttribute('aria-label',tx(`Comparar ${compare.size} modelos seleccionados`,`Compare ${compare.size} selected models`))}
function toggleProject(id){if(!byId.has(id))return;const p=byId.get(id);if(project.has(id)){project.delete(id);toast(tx(p.name+' se ha retirado del proyecto.',pName(p)+' removed from your project.'))}else{project.add(id);toast(tx(p.name+' añadido a tu proyecto.',pName(p)+' added to your project.'))}refreshToggles();renderProject();}
function openProduct(id){const p=byId.get(id);if(!p)return;openProductId=id;const config=configurations.get(id)||{};const page=n=>tx(' · página ',' · page ')+n;const choose=tx('Por definir con el equipo','To be defined with the team');q('#product-detail-content').innerHTML=`<div class="product-detail-main"><div class="detail-gallery ${p.contain?'contain':''}">${media(p,'detail-main-image',false)}<div class="detail-source">${escape(pImageSource(p))}${p.imageSource?(p.imagePage?page(p.imagePage):''):page(p.page)} · ${p.id==='wv-mini-mat'?tx('Imagen proporcionada para este modelo.','Image supplied for this model.'):p.image?tx('Fotografía de catálogo.','Catalogue photograph.'):tx('Sin fotografía específica verificada.','No verified photograph for this model.')}</div></div><div class="detail-info"><span class="eyebrow">${escape(catLabels()[p.category])}</span><h2>${escape(pName(p))}</h2><p class="detail-summary">${escape(pSummary(p))}</p><ul class="detail-features">${pFeatures(p).map(f=>`<li>${escape(f)}</li>`).join('')}</ul>${p.category==='saunas'?`<div class="sauna-config"><label>${tx('Tu preferencia de madera','Your wood preference')}<select id="wood-preference"><option value="Por definir">${choose}</option>${['Abeto','Ayous (Samba)','Ayous alistonado'].map(w=>`<option value="${escape(w)}" ${config.wood===w?'selected':''}>${escape(vEn(w))}</option>`).join('')}</select></label><label>${tx('Tu preferencia de iluminación','Your lighting preference')}<select id="light-preference"><option value="Por definir">${choose}</option>${['LED cálida','LED RGB'].map(v=>`<option value="${escape(v)}" ${config.light===v?'selected':''}>${escape(vEn(v))}</option>`).join('')}</select></label><small>${tx('Preferencias iniciales; compatibilidad y configuración sujetas a valoración.','Initial preferences; compatibility and configuration subject to review.')}</small></div>`:''}<label class="detail-quantity">${tx('Cantidad deseada','Desired quantity')} <input type="number" id="detail-quantity" min="1" max="99" step="1" value="${quantities.get(p.id)||1}" aria-label="${tx('Cantidad de','Quantity of')} ${escape(pName(p))}"></label><div class="detail-actions"><button type="button" class="button dark" data-project="${escape(p.id)}" aria-pressed="${project.has(p.id)}">${buttonProject(p)}</button><button type="button" class="button outline" data-compare="${escape(p.id)}" aria-pressed="${compare.has(p.id)}">${compare.has(p.id)?tx('Quitar de comparativa','Remove from compare'):tx('Comparar este modelo','Compare this model')}</button></div>${p.category==='saunas'?`<button type="button" class="detail-configure-sauna text-link">${tx('Configurar medidas y capacidad','Configure size and capacity')} <span>↗</span></button>`:''}<button type="button" class="detail-go-project text-link">${tx('Ver mi proyecto','View my project')} <span>↗</span></button><p class="detail-note">${p.id==='hiperbaricas'?tx('La selección y la operación requieren validación técnica y de los requisitos aplicables. No se presentan indicaciones ni resultados clínicos.','Selection and operation require technical validation and a review of the applicable requirements. No clinical indications or results are presented.'):tx('La configuración, instalación y disponibilidad se confirman en la propuesta. No se muestran precios ni plazos estimados.','Configuration, installation and availability are confirmed in the proposal. No prices or estimated lead times are shown.')}</p></div></div><div class="detail-bottom"><h3>${tx('Lo que conviene saber','Good to know')}</h3><dl class="spec-grid">${Object.entries(pSpecs(p)).map(([k,v])=>`<div><dt>${escape(k)}</dt><dd>${escape(v)}</dd></div>`).join('')}<div><dt>${tx('DOCUMENTACIÓN','DOCUMENTATION')}</dt><dd>${escape(pSource(p))}, p. ${p.page}</dd></div></dl><p class="detail-note">${p.category==='saunas'?tx('Dimensiones, potencia, aislamiento, base, ventilación y preinstalaciones se validan por proyecto.','Dimensions, power, insulation, base, ventilation and pre-installation are validated per project.'):tx('Datos resumidos del catálogo facilitado. Los valores no publicados o pendientes de aclaración se confirman con el equipo.','Summary data from the catalogue provided. Unpublished values or values pending clarification are confirmed with the team.')}</p></div>`;q('#product-dialog').setAttribute('aria-label',tx('Ficha de ','Product sheet: ')+pName(p));if(!q('#product-dialog').open)q('#product-dialog').showModal();q('#detail-quantity').addEventListener('change',()=>{setQuantity(id,q('#detail-quantity').value);q('#detail-quantity').value=quantities.get(id)});if(p.category==='saunas'){['#wood-preference','#light-preference'].forEach(s=>q(s).addEventListener('change',()=>{configurations.set(id,{...(configurations.get(id)||{}),wood:q('#wood-preference').value,light:q('#light-preference').value});renderProject()}))}}
function compareRows(p){const pick=re=>{const idx=p.features.findIndex(f=>re.test(f));return idx<0?null:pFeatures(p)[idx]};const dim=pick(/dimensiones|\d[\d.,]*\s*[×x]|longitud exterior/i);const material=pick(/acero|madera|cedro|abeto|tsuga|WPC|acabados/i);const ask=tx('Consultar según configuración','Ask, depending on configuration');return[[tx('Tipo de solución','Solution type'),catLabels()[p.category]],[tx('Formato','Format'),pSummary(p)],[tx('Dimensiones publicadas','Published dimensions'),dim||ask],[tx('Materiales / acabados','Materials / finishes'),material||ask],[tx('Características de catálogo','Catalogue features'),pFeatures(p).join(' · ')],[tx('Fuente','Source'),pSource(p)+' · p. '+p.page]]}
function renderComparison(){q('#comparison-content').innerHTML=compare.size?`<div class="comparison-grid" style="--compare-cols:${compare.size}">${[...compare].map(id=>{const p=byId.get(id);return`<article class="comparison-product">${media(p,p.contain?'contain':'')}<span class="eyebrow">${escape(catLabels()[p.category])}</span><h3>${escape(pName(p))}</h3><dl>${compareRows(p).map(([k,v])=>`<div><dt>${escape(k)}</dt><dd>${escape(v)}</dd></div>`).join('')}</dl><button type="button" class="button dark" data-project="${escape(id)}" aria-pressed="${project.has(id)}">${buttonProject(p)}</button><button type="button" class="remove-compare" data-remove-comparison="${escape(id)}">${tx('Retirar de la comparativa','Remove from comparison')}</button></article>`}).join('')}</div><p class="form-note">${tx('Puedes deslizar horizontalmente si la comparativa no cabe en tu pantalla. Esta tabla compara características de catálogo, no resultados clínicos.','Swipe sideways if the comparison does not fit your screen. This table compares catalogue features, not clinical results.')}</p>`:`<p class="comparison-empty">${tx('Tu comparativa está vacía. Cierra esta ventana y elige hasta tres modelos en la colección.','Your comparison is empty. Close this window and choose up to three models from the collection.')}</p>`}
q('#open-comparison').addEventListener('click',()=>{if(compare.size<2){toast(tx('Elige al menos dos modelos para comparar.','Choose at least two models to compare.'));return}renderComparison();q('#comparison-dialog').showModal()});q('#clear-comparison').addEventListener('click',()=>{compare.clear();refreshToggles();renderCompareBar()});
function setQuantity(id,value){const number=Number(value);quantities.set(id,Number.isFinite(number)?Math.max(1,Math.min(99,Math.round(number))):1);renderProject();}
function renderProject(){const root=q('#selected-project-products');const n=project.size;root.innerHTML=`<span class="eyebrow">${tx(`TU SELECCIÓN · ${n} ${n===1?'MODELO':'MODELOS'}`,`YOUR SELECTION · ${n} ${n===1?'MODEL':'MODELS'}`)}</span>`+(n?[...project].map(id=>{const p=byId.get(id),c=configurations.get(id);return`<div class="selected-product">${p.image?`<img src="${escape(p.image)}" alt="">`:'<span class="selected-product-placeholder">WV</span>'}<span>${escape(pName(p))}${c?`<small>${escape([c.location,c.wood,c.light].filter(x=>x&&x!=='Por definir').map(vEn).join(' · '))}</small>`:''}</span><label class="quantity-control"><span class="sr-only">${tx('Cantidad de','Quantity of')} ${escape(pName(p))}</span><input type="number" min="1" max="99" step="1" data-product-quantity="${escape(id)}" value="${quantities.get(id)||1}"></label><button type="button" data-remove-project="${escape(id)}" aria-label="${escape(tx(`Retirar ${p.name} del proyecto`,`Remove ${pName(p)} from project`))}">×</button></div>`}).join(''):`<p class="selection-empty">${tx('Puedes empezar sin un modelo concreto, o <a href="#catalogo">explorar las categorías</a> y añadir tus favoritos.','You can start without a specific model, or <a href="#catalogo">explore the categories</a> and add your favourites.')}</p>`);}
wv.getProjectProductNames=()=>project.size?[...project].map(id=>'- '+(quantities.get(id)||1)+' × '+pName(byId.get(id))).join('\n'):tx('Sin modelos concretos todavía','No specific models yet');
wv.getSaunaConfigurationSummary=()=>{const configs=[...project].filter(id=>byId.get(id).category==='saunas'&&configurations.has(id));const tbd=tx('Por definir','To be defined');const posture=c=>c.posture==='lying'?tx('tumbadas','lying down'):tx('sentadas','seated');const reference=c=>c.reference?`${c.reference.width} × ${c.reference.depth} cm · ${c.reference.count} ${posture(c)} · ${tx('catálogo de saunas p. 4 · orientativo','sauna catalogue p. 4 · indicative')}`:tx('Sin referencia de catálogo para el aforo solicitado','No catalogue reference for the requested capacity');return configs.length?configs.map(id=>{const c=configurations.get(id);const qty=quantities.get(id)||1;return pName(byId.get(id))+' ('+qty+(qty===1?tx(' unidad',' unit'):tx(' unidades',' units'))+'):\n'+(c.custom?tx('Entorno','Setting')+': '+vEn(c.location)+'\n'+tx('Personas previstas','Expected people')+': '+c.persons+' '+posture(c)+'\n'+tx('Medidas deseadas (ancho × fondo × alto)','Preferred size (width × depth × height)')+': '+[c.width,c.depth,c.height].map(v=>v?v+' cm':tx('por definir','to be defined')).join(' × ')+'\n'+tx('Referencia orientativa de catálogo','Indicative catalogue reference')+': '+reference(c)+'\n':'')+tx('Madera interior','Interior wood')+': '+(c.wood?vEn(c.wood):tbd)+'\n'+tx('Acabados deseados','Preferred finishes')+': '+(c.finishes&&c.finishes.length?c.finishes.map(vEn).join(', '):tbd)+'\n'+tx('Iluminación','Lighting')+': '+(c.light?vEn(c.light):tbd)+'\n'+tx('Configuración pendiente de validación técnica.','Configuration pending technical validation.')}).join('\n\n'):tx('Sin configuración de sauna a medida todavía','No custom sauna configuration yet');};
wv.addConfiguredSauna=(id,config,quantity)=>{if(!byId.has(id))return false;configurations.set(id,{...config,custom:true});project.add(id);setQuantity(id,quantity);refreshToggles();renderProject();return true};
root.addEventListener('change',e=>{if(e.target.matches('[data-product-quantity]'))setQuantity(e.target.dataset.productQuantity,e.target.value)});
function setStep(n){step=Math.max(0,Math.min(2,n));qa('[data-builder-step]').forEach(el=>el.hidden=Number(el.dataset.builderStep)!==step);qa('[data-step]').forEach(b=>{const on=Number(b.dataset.step)===step;b.classList.toggle('active',on);if(on)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current')});q('#builder-back').hidden=step===0;q('#builder-next').hidden=step===2;q('#builder-submit').hidden=step!==2;q('#selected-project-products').hidden=step===0;}
qa('[data-step]').forEach(b=>b.addEventListener('click',()=>setStep(Number(b.dataset.step))));q('#builder-back').addEventListener('click',()=>setStep(step-1));q('#builder-next').addEventListener('click',()=>setStep(step+1));
const infoEn={privacidad:{title:'Your privacy,<br><em>made clear.</em>',content:'<p>This Wellness Vision professional catalogue helps you prepare your request. The catalogue, comparison and configurator run inside your browser.</p><h3>What happens to your data</h3><ul><li>This configurator does not create an account or send your request automatically. The Shopify store and its services have their own features, cookies and privacy policy.</li><li>The Weglot service handles languages and may remember your preference; the project is not saved.</li><li>Your selection and project text stay in the page memory. They are lost when you reload.</li><li>“Copy summary” writes the text to your clipboard only when you press that button.</li><li>“Open in WhatsApp” opens a draft with your summary in WhatsApp. You decide whether to send it; when you press it, the text is passed to WhatsApp to prepare that draft.</li></ul><p>Shopify serves this page and its resources. See the Wellness Vision privacy policy in the footer for how site and store data are handled.</p><p>The request goes only to +34 614 74 06 54. Once you continue in WhatsApp, processing also depends on that service and the recipient. Nothing is sent automatically from this website.</p>'},fuentes:{title:'One collection.<br><em>Four catalogues.</em>',content:'<p>This collection brings together the four Wellness Vision catalogues. You can read the product sheets in the available languages; model names are kept as published.</p><ul><li>General catalogue: 44 pages.</li><li>Sauna catalogue: 11 pages.</li><li>Ice bath catalogue: 16 pages.</li><li>Photobiomodulation catalogue: 17 pages.</li></ul><p>Each product sheet names its source catalogue and page. The photographs come from the catalogues and from images supplied specifically for this project, and are not attributed to specific clients or completed installations.</p><p>When a value needs clarification, it is not published as a confirmed specification. The final selection, availability and configuration are reviewed with the team. No clinical promises or certifications are made.</p><h3>Professional contact</h3><p>Project requests are prepared exclusively for this WhatsApp number:</p><a class="info-contact" href="https://wa.me/34614740654" target="_blank" rel="noopener noreferrer">WhatsApp · +34 614 74 06 54</a>'}};
const info={privacidad:{title:'Tu privacidad,<br><em>con claridad.</em>',content:'<p>Este catálogo profesional de Wellness Vision te ayuda a preparar tu solicitud. El catálogo, la comparativa y el configurador funcionan dentro de tu navegador.</p><h3>Qué ocurre con tus datos</h3><ul><li>Este configurador no crea una cuenta ni envía tu solicitud automáticamente. La tienda Shopify y sus servicios tienen sus propias funciones, cookies y política de privacidad.</li><li>El servicio Weglot gestiona los idiomas y puede recordar tu preferencia; el proyecto no se guarda.</li><li>La selección y el texto del proyecto permanecen en la memoria de la página. Al recargar, se pierden.</li><li>«Copiar resumen» escribe el texto en tu portapapeles solo cuando pulsas ese botón.</li><li>«Abrir en WhatsApp» abre un borrador con tu resumen en WhatsApp. Tú decides si lo envías; al pulsar, el texto se transmite a WhatsApp para preparar ese borrador.</li></ul><p>Shopify sirve esta página y sus recursos. Consulta la política de privacidad de Wellness Vision en el pie para conocer el tratamiento de datos del sitio y de la tienda.</p><p>La solicitud se dirige únicamente al número +34 614 74 06 54. Al continuar en WhatsApp, el tratamiento también depende de ese servicio y del destinatario. No hay envío automático desde esta web.</p>'},fuentes:{title:'Una colección.<br><em>Cuatro catálogos.</em>',content:'<p>Esta colección reúne los cuatro catálogos de Wellness Vision. Puedes consultar las fichas en los idiomas disponibles; se conservan los nombres de los modelos.</p><ul><li>Catálogo general: 44 páginas.</li><li>Catálogo de saunas: 11 páginas.</li><li>Catálogo de baños de inmersión: 16 páginas.</li><li>Catálogo de fotobiomodulación: 17 páginas.</li></ul><p>Cada ficha identifica su catálogo y página de origen. Las fotografías proceden de los catálogos y de las imágenes facilitadas expresamente para el proyecto, y no se atribuyen a clientes ni instalaciones ejecutadas concretas.</p><p>Cuando un dato requiere aclaración, no se publica como especificación confirmada. La selección final, disponibilidad y configuración se revisan con el equipo. No se formulan promesas clínicas ni certificaciones.</p><h3>Contacto profesional</h3><p>Las solicitudes de proyecto se preparan exclusivamente para este número de WhatsApp:</p><a class="info-contact" href="https://wa.me/34614740654" target="_blank" rel="noopener noreferrer">WhatsApp · +34 614 74 06 54</a>'}};
let openInfoKey=null;function openInfo(key){const i=(en()?infoEn:info)[key];if(!i)return;openInfoKey=key;q('#info-title').innerHTML=i.title;q('#info-content').innerHTML=i.content;if(!q('#info-dialog').open)q('#info-dialog').showModal()}
root.addEventListener('click',e=>{const open=e.target.closest('[data-open-product]');if(open){openProduct(open.dataset.openProduct);return}const c=e.target.closest('[data-compare]');if(c){toggleCompare(c.dataset.compare);return}const p=e.target.closest('[data-project]');if(p){toggleProject(p.dataset.project);return}const r=e.target.closest('[data-remove-project]');if(r){project.delete(r.dataset.removeProject);refreshToggles();renderProject();return}const rc=e.target.closest('[data-remove-comparison]');if(rc){toggleCompare(rc.dataset.removeComparison);return}const close=e.target.closest('[data-close-dialog]');if(close){close.closest('dialog').close();return}if(e.target.closest('.detail-configure-sauna')){q('#product-dialog').close();if(wv.selectSaunaFamily)wv.selectSaunaFamily(openProductId);location.hash='configurador-sauna';return}if(e.target.closest('.detail-go-project')){q('#product-dialog').close();setStep(1);location.hash='proyecto';return}const infoButton=e.target.closest('[data-open-info]');if(infoButton)openInfo(infoButton.dataset.openInfo)});
qa('#product-dialog, #comparison-dialog, #info-dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target!==d)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close()}));
q('#solution-source').dataset.catalogCategory='saunas';renderCatalog();renderCompareBar();renderProject();setStep(0);activateSolution(activeSolution);activateSector(activeSector);
})();

'use strict';
(()=>{
const q=s=>root.querySelector(s), form=q('#sauna-config-form');
const woods=[{name:'Abeto',image:'abeto-user-v5.webp'},{name:'Ayous (Samba)',image:'ayous-user-v5.webp'},{name:'Ayous alistonado',image:'ayous-alistonado-user-v5.webp'}];
const references=[{width:120,depth:120,seated:1,lying:0},{width:150,depth:150,seated:2,lying:0},{width:200,depth:150,seated:4,lying:2},{width:200,depth:200,seated:5,lying:2},{width:250,depth:250,seated:8,lying:4},{width:250,depth:350,seated:10,lying:6}];
let wood='Por definir',currentReference=null;const finishes=new Set();
const crop=()=>tx(' · recorte de la imagen facilitada',' · crop of the supplied image');
function renderWoods(){q('#wood-swatches').setAttribute('aria-label',tx('Elegir madera del catálogo','Choose a catalogue wood'));q('#wood-swatches').innerHTML=woods.map(w=>`<button type="button" class="wood-swatch" data-wood="${w.name}" aria-pressed="${wood===w.name}"><img src="${wvAsset("assets/user/"+w.image)}" alt="${vEn(w.name)}${crop()}" width="608" height="313" loading="lazy"><span>${vEn(w.name)}</span><small>${tx('Preferencia de madera interior','Interior wood preference')}</small></button>`).join('');}
renderWoods();
const finishPanel=document.createElement('div');finishPanel.className='finish-panel';
const finishItems=[{name:'Barnizado ecológico',image:'barnizado-ecologico-user-v5.webp',w:607,h:302,kind:{es:'Preferencia de acabado',en:'Finish preference'}},{name:'Panelado horizontal',image:'panelado-horizontal-user-v5.webp',w:1226,h:286,kind:{es:'Preferencia de disposición',en:'Layout preference'}}];
function renderFinishes(){finishPanel.innerHTML=`<p class="finish-panel-title">${tx('Acabados opcionales','Optional finishes')}</p><p class="config-help">${tx('Preferencias de acabado, independientes de la especie de madera. Su aplicación se confirma con el equipo.','Finish preferences, independent of the wood species. How they are applied is confirmed with the team.')}</p><div class="finish-swatches">`+finishItems.map(f=>`<button type="button" class="wood-swatch" data-finish="${f.name}" aria-pressed="${finishes.has(f.name)}"><img src="${wvAsset("assets/user/"+f.image)}" alt="${vEn(f.name)}${crop()}" width="${f.w}" height="${f.h}" loading="lazy"><span>${vEn(f.name)}</span><small>${tx(f.kind.es,f.kind.en)}</small></button>`).join('')+'</div>';}
renderFinishes();q('#wood-swatches').after(finishPanel);finishPanel.addEventListener('click',e=>{const b=e.target.closest('[data-finish]');if(!b)return;const f=b.dataset.finish;if(finishes.has(f))finishes.delete(f);else finishes.add(f);b.setAttribute('aria-pressed',String(finishes.has(f)));});
const outdoorNote=document.createElement('p');outdoorNote.className='config-help exterior-material-note';outdoorNote.hidden=true;const outdoorCopy=()=>tx('Exterior: el catálogo contempla revestimiento tratado para intemperie; la especie exterior no se especifica. Estas muestras corresponden a la preferencia de madera interior.','Outdoor: the catalogue includes weather-treated cladding; the exterior species is not specified. These samples are for the interior wood preference.');outdoorNote.textContent=outdoorCopy();q('#wood-swatches').after(outdoorNote);
function update(){const p=(wv.WV_CATALOG||[]).find(p=>p.id===q('#sauna-family').value);if(p){q('#sauna-config-image').src=p.image;q('#sauna-config-image').alt=pName(p)+tx(' · fotografía de catálogo',' · catalogue photo');q('#sauna-preview-family').textContent=pName(p);}
const people=Number(q('#sauna-persons').value),posture=q('#sauna-posture').value;currentReference=people>=1&&Number.isInteger(people)?references.find(r=>r[posture]>=people):null;
q('#capacity-recommendation').replaceChildren();const head=document.createElement('h4'),copy=document.createElement('p');if(currentReference){head.textContent=`${currentReference.width} × ${currentReference.depth} cm`;copy.textContent=tx(`Referencia orientativa de catálogo: ${currentReference[posture]} personas ${posture==='seated'?'sentadas':'tumbadas'}. Configuraciones alternativas; no se suman las plazas.`,`Indicative catalogue reference: ${currentReference[posture]} people ${posture==='seated'?'seated':'lying down'}. These are alternative layouts; the places do not add up.`);}else{head.textContent=tx('A medida, con el equipo','Made to measure, with the team');copy.textContent=people>=1?tx('La tabla del catálogo no cubre este aforo y uso. El equipo debe estudiar las medidas y la distribución.','The catalogue table does not cover this capacity and use. The team needs to study the size and layout.'):tx('Indica las personas previstas para consultar una referencia del catálogo.','Enter the expected number of people to see a catalogue reference.');}
q('#capacity-recommendation').append(head,copy);q('#apply-capacity').disabled=!currentReference;q('#apply-capacity').hidden=!currentReference;
const w=q('#sauna-width').value,d=q('#sauna-depth').value,h=q('#sauna-height').value;q('#sauna-preview-dimensions').textContent=w||d||h?[w||'—',d||'—',h||'—'].join(' × ')+tx(' cm · medidas deseadas',' cm · preferred size'):tx('Medidas por definir','Size to be defined');
const changed=currentReference&&w&&d&&(Number(w)!==currentReference.width||Number(d)!==currentReference.depth);q('#dimension-warning').hidden=!changed;q('#dimension-warning').textContent=changed?tx('Tus medidas difieren de la referencia de catálogo. No se calcula ni garantiza el aforo para estas medidas; debe validarse la distribución.','Your measurements differ from the catalogue reference. Capacity is not calculated or guaranteed for these measurements; the layout must be validated.'):'';
outdoorNote.hidden=q('[name="sauna-location"]:checked').value!=='Exterior';
}
q('#wood-swatches').addEventListener('click',e=>{const b=e.target.closest('[data-wood]');if(!b)return;wood=b.dataset.wood;root.querySelectorAll('[data-wood]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));});
form.addEventListener('input',update);form.addEventListener('change',update);
q('#apply-capacity').addEventListener('click',()=>{if(!currentReference)return;q('#sauna-width').value=currentReference.width;q('#sauna-depth').value=currentReference.depth;update();q('#sauna-config-status').textContent=tx('Ancho y fondo de referencia aplicados. La altura sigue pendiente de definir y validar.','Reference width and depth applied. Height still needs to be defined and validated.');});
form.addEventListener('submit',e=>{e.preventDefault();if(!form.reportValidity())return;const p=wv.WV_CATALOG.find(p=>p.id===q('#sauna-family').value);const posture=q('#sauna-posture').value;const config={location:q('[name="sauna-location"]:checked').value,persons:q('#sauna-persons').value,posture,width:q('#sauna-width').value,depth:q('#sauna-depth').value,height:q('#sauna-height').value,wood,finishes:[...finishes],light:q('#sauna-light').value,reference:currentReference?{width:currentReference.width,depth:currentReference.depth,count:currentReference[posture]}:null};if(wv.addConfiguredSauna(p.id,config,q('#sauna-quantity').value)){q('#sauna-config-status').textContent=tx(p.name+' añadida a tu selección. Si ya habías configurado esta familia, se han actualizado sus preferencias y cantidad.',pName(p)+' added to your selection. If you had already configured this family, its preferences and quantity have been updated.');const a=document.createElement('a');a.href='#proyecto';a.textContent=tx('Revisar mi proyecto ↗','Review my project ↗');a.className='text-link';q('#sauna-config-status').append(document.createElement('br'),a);}});
window.addEventListener('wv-language-change',()=>{renderWoods();renderFinishes();outdoorNote.textContent=outdoorCopy();update();q('#sauna-config-status').textContent='';});
wv.selectSaunaFamily=id=>{if([...q('#sauna-family').options].some(o=>o.value===id)){q('#sauna-family').value=id;update();}};
update();
})();

function setupWeglotSelector(root) {
  const select = root.querySelector('[data-wv-language-select]');
  const status = root.querySelector('[data-wv-language-status]');
  if (!select || !status) return;
  let active = false;
  function unavailable() {
    if (!root.isConnected || active) return;
    select.disabled = true;
    status.textContent = tx('Traducción no disponible en este momento.', 'Translation is not available right now.');
  }
  function ready() {
    if (!root.isConnected) return;
    const wg = window.Weglot;
    if (!wg || !wg.initialized || typeof wg.getAvailableLanguages !== 'function') return;
    try {
      const languages = wg.getAvailableLanguages().filter(code => typeof code === 'string' && code.length < 20);
      if (!languages.length) { unavailable(); return; }
      const current = wg.getCurrentLang();
      select.replaceChildren(...languages.map(code => {
        const option = document.createElement('option');
        option.value = code;
        option.textContent = wg.getLanguageName(code) || code.toUpperCase();
        return option;
      }));
      if (languages.includes(current)) select.value = current;
      select.disabled = languages.length < 2;
      active = true;
      status.textContent = languages.length < 2 ? tx('Solo está disponible el idioma original.', 'Only the original language is available.') : '';
    } catch (error) { unavailable(); }
  }
  const wg = window.Weglot;
  if (wg && typeof wg.on === 'function') {
    wg.on('initialized', ready);
    wg.on('languageChanged', ready);
    ready();
  }
  select.addEventListener('change', () => {
    const service = window.Weglot;
    if (!service || !service.initialized) return;
    try {
      if (service.getAvailableLanguages().includes(select.value)) service.switchTo(select.value);
    } catch (error) { status.textContent = tx('No se pudo cambiar el idioma. Inténtalo de nuevo.', 'The language could not be changed. Please try again.'); }
  });
  const timeout = setTimeout(unavailable, 10000);
  const unload = event => {
    if (!event.target.contains(root)) return;
    clearTimeout(timeout);
    if (wg && typeof wg.off === 'function') {
      wg.off('initialized', ready);
      wg.off('languageChanged', ready);
    }
    document.removeEventListener('shopify:section:unload', unload);
  };
  document.addEventListener('shopify:section:unload', unload);
}
if(window.WV_I18N){window.WV_I18N.bindSelector(root);}else{setupWeglotSelector(root);}

}function mount(){document.querySelectorAll('[data-wv-home-page]').forEach(init);}window.WV7Homepage=mount;document.addEventListener('shopify:section:load',mount);if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mount,{once:true});}else mount();})();
